<template>
<div class="chapter">
<div class="inner_page">
<h1 class="part" id="p01"><a id="page1"></a><a class="hlink" href="#/OEBPS/9780062045980_epub_toc_r1.htm#p01">ONE DAY THEY WOKE<br/>AND FOUND THEIR<br/>LIVES HAD CHANGED</a></h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062045980_epub_p01_r1.vue?c632dd4e